export const CANCEL = 'Cancel';
export const NO = 'No';
